function formatDateBr(isoDate) {
  if (!isoDate) return "Nunca realizou exame"
  const [y, m, d] = isoDate.split("-")
  if (!y || !m || !d) return isoDate
  return `${d}/${m}/${y}`
}

function labelGraduacao(value) {
  if (!value) return "—"
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export default function UserProfileDetails({ profile }) {
  if (!profile) return null

  const rows = [
    { label: "Nome completo", value: profile.nomeCompleto },
    { label: "CPF", value: profile.cpf },
    {
      label: "Data de nascimento",
      value: formatDateBr(profile.dataNascimento),
    },
    { label: "Celular", value: profile.celular },
    { label: "Graduação", value: labelGraduacao(profile.graduacao) },
    {
      label: "Último exame",
      value: formatDateBr(profile.ultimoExameEm),
    },
    { label: "E-mail", value: profile.email },
    {
      label: "Perfil",
      value: profile.role === "professor" ? "Professor" : "Aluno",
    },
  ]

  return (
    <dl className="grid gap-3 sm:grid-cols-2 ">
      {rows.map((row) => (
        <div
          key={row.label}
          className="bg-slate-100 border border-slate-200/20 rounded-xl p-3">
          <dt className="text-slate-400 text-xs uppercase tracking-wide">
            {row.label}
          </dt>
          <dd className="text-slate-900 font-medium mt-1">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
